export default __webpack_public_path__ + "static/media/edit_24.eb75bf9a.svg";